module.exports = __webpack_public_path__ + "img/fuel-station (2).c5067df1.svg";